
import { CanvasLayer }  from '@pdf-tools/four-heights-pdf-web-viewer/es6/modules/CanvasLayer';
import { CursorStyle }  from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-canvas/state/viewer';
import { Color } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/Color';
import { ViewerCanvasState } from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-canvas/state/store';
import {
  createCustomAddShapeAnnotationToolbar
} from './CustomAddShapeAnnotationToolbar';
import { getRectFromSelection, getLineRectFromSelection }
  from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-canvas/state/document';
import { AnnotationBorderStyle, PdfItemType } from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-api';
import { PdfRect } from '@pdf-tools/four-heights-pdf-web-viewer';

const moduleLayerName = 'CustomAddShapeAnnotation';

export class CustomAddShapeAnnotationLayer extends CanvasLayer {

  private context: any;
  private toolbar: any;
  private page;
  private pointerDown;
  private startPoint: any;
  private itemType: any;
  private strokeColors:any[];
  private fillColors:any[];

  constructor() {
    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    this.context = null;
    this.toolbar = null;
    this.page = 0;
    this.pointerDown = false;
    this.startPoint = null;
    this.itemType = null;
    this.strokeColors = [];
    this.fillColors = [];
  }
  onCreate(itemType: PdfItemType) {
    this.setStrokeColor = this.setStrokeColor.bind(this);
    this.setStrokeWidth = this.setStrokeWidth.bind(this);
    this.setStrokeStyle = this.setStrokeStyle.bind(this);
    this.setFillColor = this.setFillColor.bind(this);
    this.setShape = this.setShape.bind(this);
    this.cancel = this.cancel.bind(this);
    this.context = this.createCanvas();
    this.itemType = itemType;
    const annotationOptions = this.options.annotation;
    this.strokeColors = annotationOptions.colors.foregroundColors;
    this.fillColors = annotationOptions.colors.backgroundColors;
    this.store.viewer.beginModule(moduleLayerName);
    /* tslint:disable-next-line:align */
    // @ts-ignore
    const toolbarElement = this.module.toolbarElement;
    this.toolbar = createCustomAddShapeAnnotationToolbar({
      strokeColors: this.strokeColors,
      strokeWidths: annotationOptions.strokeWidths,
      fillColors: this.fillColors,
      selectedStrokeColor: annotationOptions.colors.shapeColor,
      selectedStrokeWidth: annotationOptions.shapeStrokeWidth,
      selectedStrokeStyle: annotationOptions.shapeStrokeStyle,
      selectedFillColor: annotationOptions.colors.shapeFillColor,
      selectedShape: this.itemType,
      onStrokeColorChanged: this.setStrokeColor,
      onStrokeWidthChanged: this.setStrokeWidth,
      onStrokeStyleChanged: this.setStrokeStyle,
      onFillColorChanged: this.setFillColor,
      onShapeChanged: this.setShape,
      onCancel: this.cancel,
    }, toolbarElement);
  }
  cancel() {
    this.remove();
  }

  onSave() {
    const promise = new Promise<void>((resolve, reject) => {
      resolve();
    });
    return promise;
  }

  onRemove() {
    this.removeCanvasElements();
    this.context = null;
    /* tslint:disable-next-line:align */
    // @ts-ignore
    const toolbarElement = this.module.toolbarElement;
    toolbarElement.innerHTML = '';
    this.store.viewer.setCursorStyle(CursorStyle.DEFAULT);
    this.store.viewer.endModule(moduleLayerName);
  }
  render(timestamp: number, state: ViewerCanvasState) {
    if (state.viewer.modeChanged && state.viewer.selectedModuleName !== moduleLayerName) {
      this.remove();
      return;
    }
    if (this.context) {
      const update = state.viewer.modeChanged ||
        state.pointer.positionChanged ||
        state.pointer.action ||
        state.document.zoomChanged;
      if (update) {
        const ctx = this.context;
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        const pointerPos = {
          x: state.pointer.x.devicePixels,
          y: state.pointer.y.devicePixels,
        };
        const pointerPdfPos = this.pdfApi.transformScreenPointToPdfPoint(pointerPos);
        if (pointerPdfPos.isOnPage) {
          this.store.viewer.setCursorStyle(CursorStyle.CROSSHAIR);
        }
        else {
          this.store.viewer.setCursorStyle(CursorStyle.NOT_ALLOWED);
        }
        if (state.pointer.isDown) {
          if (!this.pointerDown) {
            this.startPoint = pointerPos;
            this.pointerDown = true;
            if (this.page === 0 && pointerPdfPos.isOnPage) {
              this.page = pointerPdfPos.pdfPoint.page;
            }
          }
          if (this.startPoint) {
            const rect = getRectFromSelection(state.document, {
              x: this.startPoint.x,
              y: this.startPoint.y,
            }, {
              x: pointerPos.x,
              y: pointerPos.y,
            }, this.page);
            const annotationOptions = this.options.annotation;
            if (rect) {
              ctx.save();
              const strokeColor = new Color(annotationOptions.colors.shapeColor);
              ctx.strokeStyle = strokeColor.toRgb();
              const fillColor = new Color(annotationOptions.colors.shapeFillColor);
              ctx.fillStyle = fillColor.toRgb();
              const lineWidth = annotationOptions.shapeStrokeWidth * devicePixelRatio * state.document.zoom;
              ctx.lineWidth = lineWidth;
              if (lineWidth) {
                ctx.globalAlpha = strokeColor.a;
              }
              else {
                ctx.globalAlpha = fillColor.a;
              }
              if (this.options.annotation.shapeStrokeStyle === AnnotationBorderStyle.DASHED) {
                ctx.setLineDash([ctx.lineWidth]);
              }
              if (this.itemType === PdfItemType.CIRCLE) {
                const cX = rect.x + rect.w / 2;
                const cY = rect.y + rect.h / 2;
                ctx.beginPath();
                ctx.ellipse(cX, cY, Math.max(rect.w / 2 - ctx.lineWidth / 2, 0), Math.max(rect.h / 2 - ctx.lineWidth / 2, 0), 0, 0, Math.PI * 2);
                if (fillColor.a) {
                  ctx.fill();
                }
                if (annotationOptions.shapeStrokeWidth) {
                  ctx.stroke();
                }
              }
              else if (this.itemType === PdfItemType.LINE) {
                ctx.beginPath();
                 ctx.moveTo(this.startPoint.x, this.startPoint.y); // start
                ctx.lineTo(pointerPos.x, pointerPos.y); // end
                //ctx.moveTo(pointerPos.x, pointerPos.y);
                //ctx.lineTo(this.startPoint.x, this.startPoint.y);
                ctx.stroke(); // Render the path
              }
              else {
                if (fillColor.a) {
                  ctx.fillRect(rect.x, rect.y, rect.w, rect.h);
                }
                if (annotationOptions.shapeStrokeWidth) {
                  ctx.strokeRect(rect.x + ctx.lineWidth / 2, rect.y + ctx.lineWidth / 2, rect.w - ctx.lineWidth, rect.h - ctx.lineWidth);
                }
              }
              ctx.restore();
            }
          }
        }
        else if (this.pointerDown && this.startPoint) {
          if (this.itemType === PdfItemType.LINE) {
            // special handling for line, as start and end point are relevant

            const rect = getLineRectFromSelection(state.document, {
              x: this.startPoint.x,
              y: this.startPoint.y,
            }, {
              x: pointerPos.x,
              y: pointerPos.y,
            }, this.page)
            if (rect) {
              this.pointerDown = false;
              this.startPoint = null;
              this.createLineAnnotation(rect);
            }
          } else {
            const rect = getRectFromSelection(state.document, {
              x: this.startPoint.x,
              y: this.startPoint.y,
            }, {
              x: pointerPos.x,
              y: pointerPos.y,
            }, this.page);
            if (rect) {
              this.pointerDown = false;
              this.startPoint = null;
              this.createRectangleAnnotation(rect);
            }
          }
        }
      }
    }
  }
  setStrokeColor(color: any) {
    this.options.annotation.colors.shapeColor = color;
  }
  setShape(shape: any) {
    this.itemType = shape;
  }
  setStrokeWidth(width: any) {
    this.options.annotation.shapeStrokeWidth = width;
  }
  setStrokeStyle(style: any) {
    this.options.annotation.shapeStrokeStyle = style;
  }
  setFillColor(color: any) {
    this.options.annotation.colors.shapeFillColor = color;
  }

  createRectangleAnnotation(rect: any) {
    const pdfRect = this.pdfApi.transformScreenRectToPdfRect(rect, this.page);
    const annotationOptions = this.options.annotation;
    const annotation = {
      itemType: this.itemType,
      color: annotationOptions.colors.shapeColor,
      pdfRect,
      page: this.page,
      author: this.options.viewer.general.user,
      fillColor: annotationOptions.colors.shapeFillColor === 'transparent'
        ? null
        : annotationOptions.colors.shapeFillColor,
      border: {
        width: annotationOptions.shapeStrokeWidth,
        style: this.options.annotation.shapeStrokeStyle,
      },
    };
    this.pdfApi
      .createItem(annotation)
      .then(() => {
        this.remove();
      })
      .catch((err) => {
        console.error(err);
      });
  }
  createLineAnnotation(rect: any) {
    const startPoint = this.pdfApi.transformScreenPointToPdfPoint({x: rect.x, y: rect.y});
    const endPoint = this.pdfApi.transformScreenPointToPdfPoint({x: rect.w, y: rect.h});
    const pdfRect: PdfRect = {
      pdfX: startPoint.pdfPoint.pdfX,
      pdfY: startPoint.pdfPoint.pdfY,
      pdfW: endPoint.pdfPoint.pdfX ,
      pdfH: endPoint.pdfPoint.pdfY,
      page: this.page
    }
    const start={
      pdfX: startPoint.pdfPoint.pdfX,
      pdfY: startPoint.pdfPoint.pdfY,
      page: startPoint.pdfPoint.page
    }
    const end={
      pdfX: endPoint.pdfPoint.pdfX,
      pdfY: endPoint.pdfPoint.pdfY,
      page: endPoint.pdfPoint.page
    }

    const annotationOptions = this.options.annotation;
    const annotation = {
      itemType: this.itemType,
      color: annotationOptions.colors.shapeColor,
      pdfRect,      start, end,
      page: this.page,
      author: this.options.viewer.general.user,
      fillColor: annotationOptions.colors.shapeFillColor === 'transparent'
        ? null
        : annotationOptions.colors.shapeFillColor,
      border: {
        width: annotationOptions.shapeStrokeWidth,
        style: this.options.annotation.shapeStrokeStyle,
      },
    };

    this.pdfApi
      .createItem(annotation)
      .then(() => {
        this.remove();
      })
      .catch((err) => {
        console.error(err);
      });
  }

}
